'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Box from '@mui/material/Box';
import { NavItem } from './NavItem';
import { navCssClassNames } from './navCssClassNames';
import { StyledNavDrawer } from './base/StyledNavDrawer';
import { StyledNavItemButton } from './base/StyledNavItemButton';
import { StyledDrawerNav } from './base/StyledDrawerNav';
import { StackedNavList } from './base/StackedNavList';
import { NavDrawerHeader } from './NavDrawerHeader';
export const NavItemDrawer = ({ label, selected, anchor, subNavigationItems: items, onClose, onClick, container, FlyoutContent, level, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const nextLevel = level ? level + 1 : 1;
    const handleNavItemClick = (event) => {
        onClick?.(event);
        setIsOpen(true);
    };
    const handleIconButtonClick = () => {
        setIsOpen(false);
    };
    const recursiveSubDrawerProps = {
        onClose,
        anchor,
        variant: 'persistent'
    };
    return (_jsxs(_Fragment, { children: [_jsx(StyledNavItemButton, { className: navCssClassNames.itemDrawerButton, endIcon: _jsx(KeyboardArrowRight, {}), onClick: handleNavItemClick, orientation: 'side', selected: selected, ...props, children: label }), _jsx(StyledNavDrawer, { ...recursiveSubDrawerProps, open: isOpen, children: _jsxs(Box, { className: navCssClassNames.drawerBox, display: 'flex', flexDirection: 'column', children: [_jsx(NavDrawerHeader, { onBackClick: handleIconButtonClick, children: label }), nextLevel === 4 && FlyoutContent ? (_jsx(FlyoutContent, { isDrawer: true, items: items })) : (_jsx(StyledDrawerNav, { className: navCssClassNames.drawerNav, children: _jsx(StackedNavList, { className: navCssClassNames.drawerList, children: items && items.map((item, itemIndex) => {
                                    return item.subNavigationItems?.length ? (_jsx(NavItem, { children: _jsx(NavItemDrawer, { ...item, ...recursiveSubDrawerProps, level: nextLevel, onClose: onClose }) }, `${item.label}-${itemIndex}`)) : (_jsx(NavItem, { children: _jsx(StyledNavItemButton, { ...item, onClick: (clickEvent) => {
                                                item.onClick?.(clickEvent);
                                                onClose?.(clickEvent, 'backdropClick');
                                            }, orientation: 'side', children: item.label }) }, `${item.label}-${itemIndex}`));
                                }) }) }))] }) })] }));
};
